import React, { Component } from "react";
import Logo from "./components/Logo";
import components from "./components/ComponentList";

import React3dNavigation from "./components/Utils/React3dNavigation";

import horse from "./assets/3d/horse.json";
import "./assets/css/main.scss";

class App extends Component {
  render() {
    return (
      <div id="main">
        <Logo />
        <React3dNavigation
          object3d={horse}
          background="#CCCCCC"
          components={components}
          initialPos={[108.83, 69.58, -15.6]}
          devMode={false}
        />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js